<script>
import ModelCreate from "../models/create";
import FormsModel from "@/components/forms/trip";
import {serialize} from "object-to-formdata";
import Swal from "sweetalert2";

export default {
  extends: ModelCreate,
  page: {
    title: "Create Trips",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('trips.singular')) }},
    resourceRoute: {default: 'trips'},
    modelVariable: {default: 'trip'},
    form: {default() { return FormsModel; }}
  },
  data() {
    return {
      title: this.lodash.startCase(this.$t('trips.plural')),
      items: [
        {
          text: this.lodash.startCase(this.$t('trips.plural')),
          href: "/trips",
        },
        {
          text: this.$t("Create New"),
          href: "/trips/create",
          active: true,
        },
      ],
      originModel: null
    }
  },
  methods: {
    confirmationModal(differenceQuantity, purchaseOrderIds) {
      let differenceSentence = `Selisih biomassa Nota Panen dengan Nota Armada sebanyak <b>${this.$numeral(differenceQuantity).format('0,0.[00]')}</b> kg.`
      let confirmSentence = `Apakah Anda ingin menyimpan dan selisih biomassa dari nota panen ${purchaseOrderIds} dibuatkan nota armada baru?`

      return Swal.fire({
        title: `${confirmSentence}`,
        html: `<span style="font-size: 14px">*${differenceSentence}</span>`,
        type: 'warning',
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: 'Ya, Simpan dan Buatkan Nota Armada Baru',
        confirmButtonColor: '#0084F3',
        cancelButtonText: 'Batal',
      })
    },
    handleStore(value) {
      if (value.difference > 0) {
        let purchaseOrderIds = value.selected_purchase_orders.map(v => v.id).join(', ').replace(/,(?!.*,)/gmi, ` ${this.$t('and')}`)
        let allowLocalMarket = value.purchase_items
            .filter(purchaseItem => purchaseItem.$checkbox && purchaseItem.purchase_order.type === 'deposit_goods')
            .reduce((total, purchaseItem) => {
              let tripItem = value.trip_items.find(tripItem => tripItem.purchase_item_id === purchaseItem.id)
              return total + (purchaseItem.available_quantity - ((tripItem || {}).quantity || 0))
            }, 0) <= 0
        this.confirmationModal(value.difference, purchaseOrderIds, allowLocalMarket)
            .then((response) => {
              if (response.isConfirmed) return this.handleStoreAndCreate(value)
            })
            .catch((error) => this.failedAlert(error))
            .finally(() => {
              this.storing = false
            })
      } else {
        return this.handleStoreAndBack(value)
      }
      // this.isConfirmModal(value)
    },
    handleStoreAndBack(value) {
      this.storing = true;
      this.store(value)
          .then((response) => {
            const {data: {data}} = response
            this.storeSuccessAlert({
              something: this.$t('trips.singular'),
              id: data.id,
            })
          })
          .then(() => {
            this.isEditing = false;
            if (localStorage.getItem('createTripAgain')) {
              localStorage.removeItem('createTripAgain')
            }
            return this.$router.push('/trips')
          })
          .catch((error) => this.failedAlert(error))
          .finally(() => {
            this.storing = false
          })
    },
    handleStoreAndCreate(value) {
      this.storing = true
      this.store(value).then((response) => {
        const { data: { data } } = response
        this.storeSuccessAlert({
          something: this.$t('trips.singular'),
          id: data.id,
        })
      }) .then(() => {
        const tripItems = value.purchase_items.map(purchaseItem => {
          let tripItem = value.trip_items.find(trip_item => trip_item.purchase_item_id === purchaseItem.id)
          let availableQuantity = (purchaseItem.available_quantity || 0) - ((tripItem || {}).quantity || 0)

          return {
            ...tripItem,
            quantity: availableQuantity,
            max_quantity: availableQuantity,
          }
        }).filter(purchaseItem => purchaseItem.quantity > 0)
        let trip = {
          ticketable: value.ticketable,
          purchase_order_id: value.purchase_order_id,
          // tripped_at: value.tripped_at,
          // vehicle_id: value.vehicle_id,
          // driver_id: value.driver_id,
          trip_items: tripItems,
        }
        localStorage.setItem('createTripAgain', JSON.stringify(trip))
      }).then(() => {
        this.isEditing = false
        window.location.reload()
      }).catch((error) => this.failedAlert(error))
          .finally(() => {
            this.storing = false
          })
    },
    handleStoreSaleOrder(value){
      this.storing = true;
      this.storeSaleOrder(value)
          .then((response) => {
            this.storing = false;
            if (localStorage.getItem('createTripAgain')) {
              localStorage.removeItem('createTripAgain')
            }
            this.$router.push({path: `/lcm/${response.data.data.id}/edit`});
          })
          .catch((error) => {
            this.failedAlert(error);
          })
          .finally(() => {
            this.storing = false;
          });
    },
    storeSaleOrder(value) {
      const saleItems = value.purchase_items.filter(purchaseItem => purchaseItem.$checkbox && purchaseItem.purchase_order.type !== 'deposit_goods').map(purchaseItem => {
        let tripItem = value.trip_items.find(trip_item => trip_item.purchase_item_id === purchaseItem.id)
        let availableQuantity = (purchaseItem.available_quantity || 0) - ((tripItem || {}).quantity || 0)
        let saleItem = {
          ...purchaseItem,
          purchase_item_id: purchaseItem.id,
          quantity: availableQuantity,
          max_quantity: availableQuantity,
          total_price: availableQuantity * purchaseItem.unit_price,
          product_id: purchaseItem.purchase_order.product_id,
          initial_quantity: availableQuantity,
          initial_size: purchaseItem.size,
          initial_unit_price: purchaseItem.unit_price
        }
        delete saleItem.id
        return saleItem
      }).filter(purchaseItem => purchaseItem.quantity > 0)
      let customerId = value.selected_purchase_orders.sort((a, b) => a -b)[0]?.customer_id
      const saleOrder = {
        customer_id: customerId,
        ordered_at: value.tripped_at,
        total: saleItems.reduce((total, saleItem) => total + (saleItem.total_price || 0), 0),
        sale_items: saleItems,
        type: 'local_market',
        ticketable: value.ticketable,
      };
      return this.$axios.post('/sale_orders', (
          serialize({...saleOrder}, { indices: true, booleansAsIntegers: true })
      ));
    },
    store(value) {
      this.originModel = value
      let val = {
        ...value,
        files: value.files.map(v => ({ path: v.file })),
        total: value.trip_items.reduce((total, v) => total + (v.total_price || 0), 0),
        ticketable: {
          ticket_id: value.ticketable.ticket_id
        }
      }
     delete val.purchase_items;

      return this.$axios.post('/trips', (
          serialize(val, { indices: true, booleansAsIntegers: true })
      ));
    },
    storeSuccessAlert(something) {
      return Swal.fire({
        title: this.$t('Success') + '!',
        text: this.$t(`You've added {something} with id {id}`, { something: something.something, id: something.id }),
        type: 'success',
        showConfirmButton: false,
        timer: 1500
      })
    },
    onStoreSuccess(value){
      return this.storeSuccessAlert(`Nota Armada dengan ID ${this.getModelName(value)}`)
    },
    getNewTrip(trip) {
      let tripItems = trip.trip_items.map(tripItem => {
        let availableQuantity = tripItem.available_quantity - tripItem.quantity
        return {...tripItem, quantity: availableQuantity, available_quantity: availableQuantity}
      }).filter(tripItem => tripItem.quantity > 0)

      return {
        ...trip,
        trip_items: tripItems,
      }
    },
  }
}
</script>
